import { call, put, select, takeEvery } from 'redux-saga/effects';

import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../../../actions/static-catalogs/vehicle-models';
import * as authSelectors from '../../../reducers/auth';
import * as schemas from '../../../schemas/vehicle-models';
import * as types from '../../../types/static-catalogs/vehicle-models';
import API_BASE_URL from '../../settings/apibaseurl';
/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchVehicleModelsList(action) {
  const maker = action.payload;
  try {
    const isAuth = yield select(authSelectors.isAuthenticated);
    if (isAuth && (maker || maker === 0)) {
      const token = yield select(authSelectors.getAuthToken);
      const response = yield call(fetch, `${API_BASE_URL}/vehicleModel/get`, {
        method: 'POST',
        body: JSON.stringify({ maker }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      const jsonResult = yield response.json();
      if (response.status <= 300 && jsonResult.success) {
        const resultData = jsonResult.data.map((result) => camelcaseKeys(result));
        const {
          entities: { vehicleModels },
          result //order
        } = normalize(resultData, schemas.vehicleModels); //normalize data to byId and order
        yield put(actions.completeFetchingVehicleModels(vehicleModels, result));
      } else {
        const error = {
          errorMessage: jsonResult.message,
          errorNumber: jsonResult.number
        };
        // alerts.showErrorAlertFailChanges({ error });
        yield put(actions.failFetchingVehicleModels(error));
      }
    }
  } catch (err) {
    const error = {
      errorMessage: err.toString(),
      errorNumber: -1
    };
    // alerts.showErrorAlertFailChanges({ error });
    yield put(actions.failFetchingVehicleModels(error));
  }
}

export function* watchFetchVehicleModelsList() {
  yield takeEvery(types.VEHICLE_MODELS_FETCH_STARTED, fetchVehicleModelsList);
}
